const KLAVIYO_REVISION = '2024-10-15';
const KLAVIYO_METRIC_NAME = 'Back In Stock Request';

function subscribeToList(companyId, listId, email) {
  return fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${companyId}`, {
    method: 'POST',
    headers: { revision: KLAVIYO_REVISION, 'content-type': 'application/json' },
    body: JSON.stringify({
      data: {
        type: 'subscription',
        attributes: {
          profile: { data: { type: 'profile', attributes: { email } } }
        },
        relationships: { list: { data: { type: 'list', id: listId } } }
      }
    })
  });
}

function trackBackInStockEvent(companyId, email, productData) {
  return fetch(`https://a.klaviyo.com/client/events/?company_id=${companyId}`, {
    method: 'POST',
    headers: { revision: KLAVIYO_REVISION, 'content-type': 'application/json' },
    body: JSON.stringify({
      data: {
        type: 'event',
        attributes: {
          properties: productData,
          metric: { data: { type: 'metric', attributes: { name: KLAVIYO_METRIC_NAME } } },
          profile: { data: { type: 'profile', attributes: { email } } }
        }
      }
    })
  });
}

function getCurrentVariantId(fallback) {
  try {
    const variant = window.Spruce && window.Spruce.store('availability').current_variant;
    if (variant && variant.id) return variant.id;
  } catch (error) {}
  return fallback;
}

function initBackInStockNotify(root) {
  const toggleBtn = root.querySelector('.back-in-stock-toggle');
  const form = root.querySelector('.back-in-stock-form');
  const emailInput = root.querySelector('.back-in-stock-email');
  const submitBtn = root.querySelector('.back-in-stock-submit');
  const message = root.querySelector('.back-in-stock-message');

  if (!toggleBtn || !form || !emailInput || !submitBtn || !message) return;

  toggleBtn.addEventListener('click', () => {
    toggleBtn.hidden = true;
    form.style.display = 'flex';
    emailInput.focus();
  });

  const submit = async () => {
    const email = emailInput.value.trim();
    if (!email || !emailInput.reportValidity()) return;

    submitBtn.disabled = true;
    message.hidden = true;

    const { klaviyoCompanyId: companyId, klaviyoListId: listId, productName, productId, variantId, productUrl } = root.dataset;

    try {
      await Promise.all([
        subscribeToList(companyId, listId, email),
        trackBackInStockEvent(companyId, email, {
          product_name: productName,
          product_id: productId,
          variant_id: getCurrentVariantId(variantId),
          product_url: productUrl
        })
      ]);

      message.textContent = "You're on the list — we'll email you when it's back in stock.";
      message.hidden = false;
      form.style.display = 'none';
    } catch (error) {
      message.textContent = 'Something went wrong. Please try again.';
      message.hidden = false;
      submitBtn.disabled = false;
    }
  };

  submitBtn.addEventListener('click', submit);
  emailInput.addEventListener('keydown', (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      submit();
    }
  });
}

document.querySelectorAll('.back-in-stock-notify').forEach(initBackInStockNotify);
